import RoamingStore from '../../../stores/RoamingStore';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Segment } from '../../../stores/SegmentStore';
import { GroupService } from '../../RoamingInterfaces';
import ServicePriceItem from './ServicePriceItem';
import { Table, TableCell } from 'telia-front-react';
import VatInfoNotice from './VatInfoNotice';

interface GroupServiceTableProps {
  segment: Segment;
  serviceGroupId: number;
  roamingStore?: RoamingStore;
}

const GroupServiceTable = (props: GroupServiceTableProps): JSX.Element => {
  const {
    roamingStore: { selectedOperatorServiceGroupById, selectedOperator },
    segment,
    serviceGroupId
  } = props;
  const serviceGroup = selectedOperatorServiceGroupById(serviceGroupId);

  return (
    <>
      <VatInfoNotice segment={segment} />
      <Table responsive="rows" className="text__margin-none">
        <tbody>
          {serviceGroup.groupServices.map((service: GroupService, index: number): JSX.Element => {
            const hasPrice = !!service.servicePrices && !!service.servicePrices.length;
            return (
              <tr key={`operator-${selectedOperator.id}-${serviceGroupId}-${index}-group`}>
                <TableCell type="th" scope="row" colSpan={hasPrice ? 1 : 2}>
                  {service.name}
                </TableCell>
                {hasPrice && (
                  <TableCell>
                    <p className="text-right">
                      <ServicePriceItem segment={segment} service={service} />
                    </p>
                  </TableCell>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default inject('roamingStore')(observer(GroupServiceTable));
